import { api } from 'api/api';
import { urls } from 'api/urls';

import type { IrradiacaoParams } from './irradiacao.types';

const listarIrradiacoes = async (params: IrradiacaoParams) => await api.get(`${urls.irradiacao}`, { params: params });

export { listarIrradiacoes };
